var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { asNumber } from "@/lib/number-utils";
import { FORMULAS } from "@/lib/formulas";
function extractDelegacion(delegacionZonaVentas) {
    return (delegacionZonaVentas === null || delegacionZonaVentas === void 0 ? void 0 : delegacionZonaVentas.slice(0, 4)) || delegacionZonaVentas;
}
function firstNonEmptyDistribuidor(periods) {
    const distribuidor = periods
        .map((period) => { var _a; return (_a = period.distribuidor) === null || _a === void 0 ? void 0 : _a.toString().trim(); })
        .find((value) => Boolean(value));
    return distribuidor || null;
}
function computeCumplimientoTotals(rows, period, fieldKey) {
    const totals = rows.reduce((accumulator, row) => {
        var _a, _b;
        const value = (_b = (_a = row.periods) === null || _a === void 0 ? void 0 : _a[period]) === null || _b === void 0 ? void 0 : _b[fieldKey];
        accumulator.obj += asNumber(value === null || value === void 0 ? void 0 : value.obj);
        accumulator.rtdo += asNumber(value === null || value === void 0 ? void 0 : value.rtdo);
        return accumulator;
    }, { obj: 0, rtdo: 0 });
    return FORMULAS.compute_cumplimiento(totals);
}
function computeUniqueBultos(rows, period) {
    const bultos = rows
        .map((row) => { var _a, _b; return (_b = (_a = row.periods) === null || _a === void 0 ? void 0 : _a[period]) === null || _b === void 0 ? void 0 : _b.bultos; })
        .filter((value) => value !== null && value !== undefined && value !== "");
    const uniqueValues = Array.from(new Set(bultos.map((value) => String(value)))).map((value) => asNumber(value));
    if (uniqueValues.length === 0) {
        return null;
    }
    if (uniqueValues.length === 1) {
        return uniqueValues[0];
    }
    return uniqueValues.reduce((sum, value) => sum + value, 0);
}
function countAchievedObjectives(periodData) {
    const cumplimientoKeys = ["ho_f1", "ho_f2", "ho_f3", "al_f1", "al_f2", "al_f3"];
    return cumplimientoKeys.reduce((count, key) => {
        var _a;
        return count + ((asNumber((_a = periodData === null || periodData === void 0 ? void 0 : periodData[key]) === null || _a === void 0 ? void 0 : _a.percent) >= 1) ? 1 : 0);
    }, 0);
}
export function formatLevanteData(row) {
    return __awaiter(this, void 0, void 0, function* () {
        let format = {
            delegacion: extractDelegacion(row.delegacion_zona_de_ventas),
            delegacion_zona_de_ventas: row.delegacion_zona_de_ventas,
            distribuidor: firstNonEmptyDistribuidor(row.periods),
            routeCodes: [row.delegacion_zona_de_ventas],
            periods: {},
            total_objetivos_conseguidos: 0
        };
        row.periods.forEach(period => {
            var _a, _b;
            let num_objetivos_conseguidos = 0;
            const ho_f1 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_ho_f1),
                rtdo: asNumber(period.rtdo_ho_f1)
            });
            if (ho_f1.percent >= 1)
                num_objetivos_conseguidos++;
            const ho_f2 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_ho_f2),
                rtdo: asNumber(period.rtdo_ho_f2)
            });
            if (ho_f2.percent >= 1)
                num_objetivos_conseguidos++;
            const ho_f3 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_ho_f3),
                rtdo: asNumber(period.rtdo_ho_f3)
            });
            if (ho_f3.percent >= 1)
                num_objetivos_conseguidos++;
            const al_f1 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_al_f1),
                rtdo: asNumber(period.rtdo_al_f1)
            });
            if (al_f1.percent >= 1)
                num_objetivos_conseguidos++;
            const al_f2 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_al_f2),
                rtdo: asNumber(period.rtdo_al_f2)
            });
            if (al_f2.percent >= 1)
                num_objetivos_conseguidos++;
            const al_f3 = FORMULAS.compute_cumplimiento({
                obj: asNumber(period.obj_al_f3),
                rtdo: asNumber(period.rtdo_al_f3)
            });
            if (al_f3.percent >= 1)
                num_objetivos_conseguidos++;
            format.periods[period.period] = {
                ho_f1,
                ho_f2,
                ho_f3,
                al_f1,
                al_f2,
                al_f3,
                bultos: period.bultos,
                num_objetivos_conseguidos: num_objetivos_conseguidos,
                objetivos_conseguidos_rev_rows: (_a = period.num_objetivos_conseguidos) !== null && _a !== void 0 ? _a : num_objetivos_conseguidos,
            };
            format.total_objetivos_conseguidos += (_b = period.num_objetivos_conseguidos) !== null && _b !== void 0 ? _b : num_objetivos_conseguidos;
        });
        return format;
    });
}
export function tableFieldsLevante(data) {
    let rows = [
        {
            key: "delegacion",
            label: "Delegación",
            type: "string",
            align: "left",
            width: "140px"
        },
        {
            key: "distribuidor",
            label: "Distribuidor",
            type: "string",
            align: "left",
            width: "260px"
        }
    ];
    let bultos_rows = [];
    let objetivos_conseguidos_rows = [];
    let objetivos_conseguidos_rev_rows = [];
    Object.keys(data[0].periods).forEach((period) => {
        rows = [...rows,
            {
                key: "periods." + period + ".ho_f1",
                label: "FANTA / SPRITE VIDRIO P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".ho_f1.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f1.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f1.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f1.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
            {
                key: "periods." + period + ".ho_f2",
                label: "ROYAL BLISS / NORDIC MIST VIDRIO P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".ho_f2.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f2.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f2.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f2.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
            {
                key: "periods." + period + ".ho_f3",
                label: "FUZE TEA VR P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".ho_f3.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f3.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f3.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".ho_f3.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
            {
                key: "periods." + period + ".al_f1",
                label: "MONSTER / BURN P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".al_f1.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f1.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f1.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f1.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
            {
                key: "periods." + period + ".al_f2",
                label: "POWERADE P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".al_f2.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f2.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f2.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f2.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
            {
                key: "periods." + period + ".al_f3",
                label: "FUZE TEA P" + period,
                type: "group",
                children: [
                    { key: "periods." + period + ".al_f3.obj", label: "Objetivo", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f3.rtdo", label: "Realizado", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f3.diff", label: "Faltantes", type: "float", align: "right" },
                    { key: "periods." + period + ".al_f3.percent", label: "% Conseguido", type: "percent", align: "right" },
                ],
            },
        ];
        bultos_rows.push({ key: "periods." + period + ".bultos", label: "Bultos P" + period, type: "integer", align: "right" });
        objetivos_conseguidos_rows.push({ key: "periods." + period + ".num_objetivos_conseguidos", label: "Nº Objvos Conseg. P" + period, type: "integer", align: "right" });
        objetivos_conseguidos_rev_rows.push({ key: "periods." + period + ".objetivos_conseguidos_rev_rows", label: "Nº Objvos Conseg. REV P" + period, type: "integer", align: "right" });
    });
    rows = [...rows, ...bultos_rows, ...objetivos_conseguidos_rows, ...objetivos_conseguidos_rev_rows,
        {
            key: "total_objetivos_conseguidos",
            label: "Nº Objvos Conseg. REV",
            type: "integer",
            align: "right"
        }
    ];
    return rows;
}
export function groupLevanteData(rows) {
    const groupedRows = new Map();
    rows.forEach((row) => {
        var _a, _b, _c;
        const delegacion = (_a = row.delegacion) !== null && _a !== void 0 ? _a : extractDelegacion(row.delegacion_zona_de_ventas);
        const distribuidor = ((_b = row.distribuidor) === null || _b === void 0 ? void 0 : _b.toString().trim()) || "(Sin distribuidor)";
        const key = distribuidor.toLowerCase();
        if (!groupedRows.has(key)) {
            groupedRows.set(key, []);
        }
        (_c = groupedRows.get(key)) === null || _c === void 0 ? void 0 : _c.push(Object.assign(Object.assign({}, row), { delegacion,
            distribuidor }));
    });
    return Array.from(groupedRows.values()).map((groupRows) => {
        const firstRow = groupRows[0];
        const periodKeys = Array.from(new Set(groupRows.flatMap((row) => { var _a; return Object.keys((_a = row.periods) !== null && _a !== void 0 ? _a : {}); }))).sort();
        const periods = {};
        let totalObjetivosConseguidos = 0;
        periodKeys.forEach((period) => {
            const aggregatedPeriod = {
                ho_f1: computeCumplimientoTotals(groupRows, period, "ho_f1"),
                ho_f2: computeCumplimientoTotals(groupRows, period, "ho_f2"),
                ho_f3: computeCumplimientoTotals(groupRows, period, "ho_f3"),
                al_f1: computeCumplimientoTotals(groupRows, period, "al_f1"),
                al_f2: computeCumplimientoTotals(groupRows, period, "al_f2"),
                al_f3: computeCumplimientoTotals(groupRows, period, "al_f3"),
                bultos: computeUniqueBultos(groupRows, period),
                num_objetivos_conseguidos: 0,
                objetivos_conseguidos_rev_rows: 0,
            };
            aggregatedPeriod.num_objetivos_conseguidos = countAchievedObjectives(aggregatedPeriod);
            aggregatedPeriod.objetivos_conseguidos_rev_rows = aggregatedPeriod.num_objetivos_conseguidos;
            totalObjetivosConseguidos += aggregatedPeriod.objetivos_conseguidos_rev_rows;
            periods[period] = aggregatedPeriod;
        });
        return Object.assign(Object.assign({}, firstRow), { delegacion: firstRow.delegacion, distribuidor: firstRow.distribuidor, routeCodes: Array.from(new Set(groupRows.flatMap((row) => { var _a; return (_a = row.routeCodes) !== null && _a !== void 0 ? _a : [row.delegacion_zona_de_ventas]; }))), periods, total_objetivos_conseguidos: totalObjetivosConseguidos });
    });
}
